import React from "react";
import styled from "@emotion/styled";
import { IoBanSharp } from "react-icons/io5";
import { colors } from "@utils/ui_palette";

function Error() {
  return (
    <Container>
      <ErrorBox>
        <IoBanSharp size={200} stroke={colors.Error10} />
        <ErrorText>Page not found.</ErrorText>
      </ErrorBox>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding-top: 300px;
`;

const ErrorBox = styled.div``;

const ErrorText = styled.div`
  font-size: 30px;
  margin-top: 30px;
`;

export default Error;
